import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';
import { PrivateSocketProvider } from './PrivateSocketContext';
import { ProjectSocketProvider } from './ProjectSocketContext';
import { lightTheme, darkTheme } from 'styles/utils';

interface State {
  themeMode: string;
}

export const AppContext = createContext<State | any>(null);

// export function AppProvider<React.FunctionComponent>({ children }: { children: React.ReactNode }) {
export function AppProvider({ children, value }: { children: React.ReactNode; value?: any }) {
  const { pathname } = useLocation();
  // const isProjectPage = `${cutUrl(pathname)}` === 'project';
  // const isAuthPage = `${cutUrl(pathname)}` === 'auth';
  const [appTheme, setAppTheme] = useState('light');
  const theme = appTheme === 'dark' ? darkTheme : lightTheme;
  // auth
  const [signInCode, setSignInCode] = useState('');
  const [uiDraggable, setUiDraggable] = useState<boolean | null>(null);

  return (
    <AppContext.Provider
      value={{
        theme,
        setAppTheme,
        signInCode,
        setSignInCode,
        uiDraggable,
        setUiDraggable,
        ...value,
      }}
    >
      <PrivateSocketProvider>
        <ProjectSocketProvider>{children}</ProjectSocketProvider>
      </PrivateSocketProvider>
    </AppContext.Provider>
  );
}

// export const useAppContextValue = () => {
//   const value = useContext(AppContext);
//   return value;
// };
